import { render, staticRenderFns } from "./create_personel.vue?vue&type=template&id=727c8620&"
import script from "./create_personel.vue?vue&type=script&lang=js&"
export * from "./create_personel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports